export enum ReviewsProductRouteTabs {
  Details = 'details',
  GlobalFeatures = 'global-features',
  Pricing = 'pricing',
  Assets = 'assets',
}

export enum ReviewsProductSubPageRoute {
  Resources = 'resources',
  Widgets = 'widgets',
  Badges = 'badges',
  Preferences = 'preferences',
  ReviewsAndCampaigns = 'reviews-campaigns',
  Overview = 'overview',
  Personalisations = 'personalisations',
  Leads = 'leads',
  TopProductsRanking = 'top-products-ranking',
  Insights = 'insights',
}

export enum ReviewsInsightsPerspective {
  Market = 'market',
  Competition = 'competition',
  Buyer = 'buyer',
  Reviews = 'reviews',
}

export enum ReviewsAgencyRouteTabs {
  Details = 'details',
  IndustriesAndServices = 'industries-services',
  Traits = 'usps-certificates',
  Partners = 'partners',
  Assets = 'assets',
}

export enum ReviewsAgencySubPageRoute {
  Widgets = 'widgets',
  Badges = 'badges',
}

export enum ReviewsRouteName {
  ReviewsProducts = 'reviewsProducts',
  ReviewsProductsIndex = 'reviewsProductsIndex',
  ReviewsProductView = 'reviewsProductView',
  ReviewsProductViewDetails = `reviewsProductView${ReviewsProductRouteTabs.Details}`,
  ReviewsProductViewAssets = `reviewsProductView${ReviewsProductRouteTabs.Assets}`,
  ReviewsProductViewGlobalFeatures = `reviewsProductView${ReviewsProductRouteTabs.GlobalFeatures}`,
  ReviewsProductViewPricing = `reviewsProductView${ReviewsProductRouteTabs.Pricing}`,

  ReviewsProductEdit = 'reviewsProductEdit',
  ReviewsProductEditDetails = `reviewsProductEdit${ReviewsProductRouteTabs.Details}`,
  ReviewsProductEditAssets = `reviewsProductEdit${ReviewsProductRouteTabs.Assets}`,
  ReviewsProductEditGlobalFeatures = `reviewsProductEdit${ReviewsProductRouteTabs.GlobalFeatures}`,
  ReviewsProductEditPricing = `reviewsProductEdit${ReviewsProductRouteTabs.Pricing}`,

  ReviewsProductReviewsAndCampaigns = `reviewsProductReviewsAndCampaigns`,
  ReviewsProductReviewDetails = `reviewsProductReviewDetails`,
  ReviewsProductCampaignOverview = `reviewsProductCampaignOverview`,
  ReviewsProductCampaignEdit = `reviewsProductCampaignEdit`,
  ReviewsProductCampaignNew = `reviewsProductCampaignNew`,
  ReviewsProductCampaignPersonalizationNew = `reviewsProductCampaignPersonalizationNew`,
  ReviewsProductCampaignPersonalizationEdit = `reviewsProductCampaignPersonalizationEdit`,

  ReviewsProductResourcesView = `reviewsProductResourcesView`,
  ReviewsProductResourcesWidgetsView = `ReviewsProductResourcesWidgetsView`,
  ReviewsProductResourcesBadgesView = `ReviewsProductResourcesBadgesView`,

  ReviewsProductPreferencesView = `reviewsProductPreferencesView`,
  ReviewsProductPreferencesEdit = `reviewsProductPreferencesEdit`,

  ReviewsProductLeads = `reviewsProductLeads`,
  ReviewsProductTopProductsRanking = `reviewsProductTopProductsRanking`,
  ReviewsProductInsights = 'reviewsProductInsights',
  ReviewsProductInsightsMarket = 'reviewsProductInsightsMarket',
  ReviewsProductInsightsCompetition = 'reviewsProductInsightsCompetition',
  ReviewsProductInsightsBuyer = 'reviewsProductInsightsBuyer',
  ReviewsProductInsightsReviews = 'reviewsProductInsightsReviews',
  ReviewsProductLeadDetail = `reviewsProductLeadDetail`,

  ReviewsAgencies = 'reviewsAgencies',
  ReviewsAgenciesIndex = 'reviewsAgenciesIndex',
  ReviewsAgencyView = 'reviewsAgencyView',
  ReviewsAgencyViewDetails = `reviewsAgencyView${ReviewsAgencyRouteTabs.Details}`,
  ReviewsAgencyViewIndustriesAndServices = `reviewsAgencyView${ReviewsAgencyRouteTabs.IndustriesAndServices}`,
  ReviewsAgencyViewTraits = `reviewsAgencyView${ReviewsAgencyRouteTabs.Traits}`,
  ReviewsAgencyViewPartners = `reviewsAgencyView${ReviewsAgencyRouteTabs.Partners}`,
  ReviewsAgencyViewAssets = `reviewsAgencyView${ReviewsAgencyRouteTabs.Assets}`,
  ReviewsAgencyEdit = 'reviewsAgencyEdit',
  ReviewsAgencyEditAssets = `reviewsAgencyEdit${ReviewsAgencyRouteTabs.Assets}`,
  ReviewsAgencyEditDetails = `reviewsAgencyEdit${ReviewsAgencyRouteTabs.Details}`,
  ReviewsAgencyEditTraits = `reviewsAgencyEdit${ReviewsAgencyRouteTabs.Traits}`,
  ReviewsAgencyEditPartners = `reviewsAgencyEdit${ReviewsAgencyRouteTabs.Partners}`,
  ReviewsAgencyEditIndustriesAndServices = `reviewsAgencyEdit${ReviewsAgencyRouteTabs.IndustriesAndServices}`,

  ReviewsAgencyResourcesView = `reviewsAgencyResourcesView`,
  ReviewsAgencyResourcesWidgetsView = `reviewsAgencyResourcesWidgetsView`,
  ReviewsAgencyResourcesBadgesView = `reviewsAgencyResourcesBadgesView`,

  ReviewsAgencyReviewsView = `reviewsAgencyReviewsView`,
  ReviewsAgencyReviewDetails = `reviewsAgencyReviewDetails`,

  ReviewsAgencyLeadsView = `reviewsAgencyLeadsView`,
  ReviewsAgencyLeadDetail = `reviewsAgencyLeadDetail`,

  ReviewsAgencyPreferencesView = `reviewsAgencyPreferencesView`,
  ReviewsAgencyPreferencesEdit = `reviewsAgencyPreferencesEdit`,
}
